module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/live-count.705ef21d.svg";